import React, { useEffect } from "react";

const ScrollToTop = () => {
  useEffect(() => {
    const handleFocus = () => {
      window.scrollTo(0, 0);
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
    };
  }, []);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
